import { createSelector } from 'reselect';

export const applicantSelector = state => state.applicant;

export const applicantTypeSelector = createSelector(
  applicantSelector,
  subState => subState.type
);

export const applicantChildSelector = createSelector(
  applicantSelector,
  subState => subState.child
);
